import { Nav } from "../components/site/Nav";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Stats } from "../components/site/Stats";
import { Threat } from "../components/site/Threat";
import { Process } from "../components/site/Process";
import { WhyUs } from "../components/site/WhyUs";
import { Plans } from "../components/site/Plans";
import { ServiceAreas } from "../components/site/ServiceAreas";
import { Testimonials } from "../components/site/Testimonials";
import { Footer } from "../components/site/Footer";
import { MobileCallBar } from "../components/site/MobileCallBar";
import { FloatingCallButton } from "../components/site/FloatingCallButton";
import { useSeo } from "../components/site/useSeo";
import { HOMEPAGE_SEO } from "../components/site/homeSeo";

export default function HomePage() {
  useSeo(HOMEPAGE_SEO);
  return (
    <div className="App" data-testid="app-root">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Stats />
        <Threat />
        <Process />
        <WhyUs />
        <Plans />
        <ServiceAreas />
        <Testimonials />
      </main>
      <Footer />
      <MobileCallBar />
      <FloatingCallButton />
    </div>
  );
}
